import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
import { USER } from '../../../../interfaces/auth.interface';
import { BeatLoader } from '../../../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const DeleteShoppingItem: React.FC<Props> = ({ 
  hideModal,
  showModal,
  modal,
  getHistory,
  deleteItem,
  deleteItemState,
  user
 }) => {

  const history = useHistory();
  const location = useLocation();

  const modalData : any = modal?.ownProps?.itemDetails;
  const [clickedStatus, setClickStatus] = React.useState(false);
  const [ itemId, setItemId ] = React.useState(modalData);
  const [success, setSuccess] = React.useState(false);

  const userObj: USER = user?.response?.Object;
  
  const closeModal = () => {
    hideModal();
  }

  // console.log('modal data',modalData);

  const deleteShoppingItem = async () => {
    // if(modalData){
      // console.log('check for modal props', modalData);
      setClickStatus(true);
    // console.log('i got here too');
    // console.log('this is the item id', modalData);
  }

  React.useEffect(() => {
    if(clickedStatus){
      fetch(`https://agilitysystemapidevm.azurewebsites.net/api/portal/deleteshopperitem/${modalData}`, { 
        method: 'delete', 
        headers: new Headers({
            'Authorization': `Basic ${userObj?.access_token}`, 
            'Content-Type': 'application/json'
        }),
        
    }) .then((res) => res.json())
    .then((res) =>  { 
      setSuccess(true);
      setClickStatus(false);
    })
    }
  })

  // console.log('user object',userObj);

  // React.useEffect(() => {
  //   if(!deleteItemState?.loading && deleteItemState?.success){
  //     hideModal();
  //     getHistory();
  //   }
  // },[!deleteItemState?.loading, deleteItemState?.success, getHistory, hideModal])

  React.useEffect(() => {
    if(success){
      hideModal();
      // getHistory();
      history.push('/shopping-history');
    }
  },[success, hideModal])
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return( 
    <div className="w-full px-4 bg-white lg:px-12 py-12 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
        </button>
        <div className="w-full my-6">
            <h2 className="mb-1 text-sm font-medium text-gray-400">Delete Item</h2>
            <p className=" w-96 text-sm text-black">Are you sure you want to delete this product from the list? </p>
        </div>

        <div className="w-full flex justify-end">
          <button className="bg-gray-300 font-medium text-sm rounded text-black p-4  m-2" type="button"
          onClick={() => closeModal()} 
          >No</button>
          <button className="bg-secondary font-medium text-sm rounded text-white p-2 m-2" 
          onClick={() => deleteShoppingItem()}
          // onClick={() => 
            
          //   deleteShoppingItem()} 
          type="button"
          >
            {clickedStatus ? <BeatLoader color="white" /> : 'Yes, Delete'}
            </button>
        </div>
     
  </div>
  );
  // </ModalWrapper>
};

export default DeleteShoppingItem;
